import { useTweakByKey } from '@/lib/tweak-store';
import type { User, UserRole } from '@mss_creator/shared';

/**
 * The role the UI should treat as active: the settings page's `user-role-override`
 * tweak when set to something other than 'inherit', otherwise `user.role`.
 * Lets role-gated UI anywhere in the app be exercised under every role from
 * the settings page, without touching the backend's real session — server-side
 * role checks are unaffected.
 */
export function useEffectiveRole(user: User): UserRole;
export function useEffectiveRole(user: User | undefined): UserRole | undefined;
export function useEffectiveRole(user: User | undefined): UserRole | undefined {
  const override = useTweakByKey('user-role-override');
  if (typeof override === 'string' && override !== 'inherit') {
    return override as UserRole;
  }
  return user?.role;
}
